export default "__VITE_ASSET__CcxEj8lX__"